import {
  RESET_ACCOUNT_STATUS,
  NBS_API_LOGOUT_SUCCESS,
  NBS_API_DEACTIVATE_ACCOUNT_SUCCESS,
  NBS_API_DELETE_ACCOUNT_SUCCESS,
  NBS_API_GET_LOGOUT_ADS_MENU_SUCCESS
} from '../../constants/actions';

const initialState = {
  // default set, need to implement in log out and on delete
  logOut: false,
  deactivate: false,
  delete: false,
  logoutAds: []
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case RESET_ACCOUNT_STATUS:
      return {...initialState};
    case NBS_API_LOGOUT_SUCCESS:
      return {
        ...state,
        logOut: true
      };
    case NBS_API_DEACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deactivate: action.isSuccess
      };
    case NBS_API_DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        delete: action.isSuccess
      };
    case NBS_API_GET_LOGOUT_ADS_MENU_SUCCESS:
      return {
        ...state,
        logoutAds: action.response && action.response.records
      };
    default:
      return state;
  }
}
